const initialState = {
  city: {
    country_id: "b340d50c-7079-4e14-af2e-8e80d0021aac",
    country_name: "India",
    icon: "/v2/city-icons/mumbai-icon.png",
    id: "03da3aba-389b-4af9-abe4-604c13bab136",
    name: "Mumbai",
    service_availables: [
      "jewellery",
      "appliance",
      "service",
      "fitnessEquipment",
      "homeEssentials",
      "entertainment",
      "kids",
      "outdoors",
    ],
    serviceable_zip_codes: null,
    state_id: "208d1160-f624-4fae-bfa1-d36d74eeb261",
    state_name: "Maharashtra",
  },
  info: "",
  cartPopup: false,
  profile: "",
};

const cart = (state = initialState, action) => {
  switch (action.type) {
    case "SELECT_CITY":
      state.city = action.data;
      return {
        ...state,
      };
    case "CART_INFO":
      state.info = action.data;
      return {
        ...state,
      };
    case "CART_POPUP":
      state.cartPopup = action.data;
      return {
        ...state,
      };
    case "GET_PROFILE":
      state.profile = action.data;
      return {
        ...state,
      };

    default:
      return state;
  }
};

export default cart;
